import React from "react";
import classNames from "classnames";

import styles from "./OpenLabel.module.scss";
import { Title } from "../Title";

export enum OpenStatus {
  Closed = "closed",
  Partial = "partial",
  Open = "open",
}

interface OpenLabelProps {
  status: OpenStatus;
  className?: string;
}

export const getOpenLabel = (status: OpenStatus): string => {
  switch (status) {
    case OpenStatus.Closed:
      return "Closed";
    case OpenStatus.Partial:
      return "Partially Open";
    case OpenStatus.Open:
      return "Open";
  }
};

const OpenLabel: React.FC<OpenLabelProps> = ({ status, className }) => {
  return (
    <Title size="small" className={classNames(styles.label, className)}>
      ▶ {getOpenLabel(status)}
    </Title>
  );
};

export { OpenLabel };
